import React from "react";
import { List } from "@material-tailwind/react";

import DashboardItem from "../MenuItems/DashboardItem";
import StudentManagementItem from "../MenuItems/StudentManagementItem";
import InterviewConfigItem from "../MenuItems/InterviewConfigItem";
import QuestionDatabaseItem from "../MenuItems/QuestionDatabaseItem";
import SchedulingItem from "../MenuItems/SchedulingItem";
import ReportEvaluationItem from "../MenuItems/ReportEvaluationItem";
import SettingsItem from "../MenuItems/SettingsItem";
import "./Style.css";

const SidebarComponent = ({ setActivePage, activePage }) => {
  return (
    <aside className="sidebar-container">
      <div className="sidebar-content">
        <List>
          <DashboardItem active={activePage === "dashboard"} onClick={() => setActivePage("dashboard")} />
          <StudentManagementItem active={activePage === "studentManagement"} onClick={() => setActivePage("studentManagement")} />
          <InterviewConfigItem active={activePage === "interviewConfig"} onClick={() => setActivePage("interviewConfig")} />
          {/* <InterviewReviewsItem active={activePage === "interviewReviews"} onClick={() => setActivePage("interviewReviews")} /> */}
          <QuestionDatabaseItem active={activePage === "questionDatabase"} onClick={() => setActivePage("questionDatabase")} />
          <SchedulingItem active={activePage === "scheduling"} onClick={() => setActivePage("scheduling")} />
          <ReportEvaluationItem active={activePage === "reportEvaluation"} onClick={() => setActivePage("reportEvaluation")} />
          <SettingsItem active={activePage === "settings"} onClick={() => setActivePage("settings")} />
        </List>
      </div>
    </aside>
  );
};

export default SidebarComponent;
